// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Bhxq","header":"PatientBlock_header__3HHXE","label":"PatientBlock_label__2Hg7V","option":"PatientBlock_option__3HcV3"};